/**
 * Fit a canvas into a container while keeping aspect ratio.
 * Shared by CanvasEditor and the editor Processing loader so sizes match.
 */
export function computeFittedCanvasSize(containerWidth, containerHeight, aspectRatio) {
  if (!containerWidth || !containerHeight || !aspectRatio || aspectRatio <= 0) {
    return null;
  }

  let width = containerWidth * 0.8;
  let height = width / aspectRatio;

  if (height > containerHeight * 0.8) {
    height = containerHeight * 0.8;
    width = height * aspectRatio;
  }

  return {
    width: Math.round(width),
    height: Math.round(height),
  };
}
